import React from 'react';
import PropTypes from 'prop-types';
import { inject, observer } from 'mobx-react';
import baseStyles from './stats-container.scss';

const guestStatsStructure = [
  { label: 'Accepted', className: 'accepted' },
  { label: 'Declined', className: 'declined' },
  { label: 'No Response', className: 'noResponse' },
];

const displayGuestStats = countArr => {
  return guestStatsStructure.map((structure, idx) => {
    const { label, className } = structure;

    return (
      <div key={idx} className={baseStyles.guestStatus}>
        <span className={`${baseStyles.guestStatusDot} ${baseStyles[className]}`}>&#8226;</span>
        {countArr[idx]}
        &nbsp;
        {label}
      </div>
    );
  });
};

export const StatsContainer = ({ noResponseCount, acceptedCount, declinedCount }) => {
  const countArr = [acceptedCount, declinedCount, noResponseCount];

  return <div className={baseStyles.guestStatsContainer}>{displayGuestStats(countArr)}</div>;
};

StatsContainer.propTypes = {
  noResponseCount: PropTypes.number.isRequired,
  acceptedCount: PropTypes.number.isRequired,
  declinedCount: PropTypes.number.isRequired,
};

export default inject('userStore')(observer(StatsContainer));
